/**
 * BT001 #12382 (S4 — Client-portal brand theming, BR-ENT-006).
 *
 * The client portal's brand/theme is driven by the account's billing-entity
 * Brand (see PortalUserProfileDto.brand from GET /api/v1/portal-users/me).
 * One app, runtime theme — the CSS-variable palette switch in
 * src/styles/globals.css does the visual work; this module supplies the
 * per-brand product identity (name, logo, alt text, aria-label).
 */

export type Brand = 'CONSCIERRA' | 'XCENTRAL';

export const DEFAULT_BRAND: Brand = 'CONSCIERRA';

export interface BrandAssets {
  readonly productName: string;
  readonly logo: string;
  readonly logoAlt: string;
  readonly homeAriaLabel: string;
  readonly icon: string;
}

export const BRANDS: Readonly<Record<Brand, BrandAssets>> = {
  CONSCIERRA: {
    productName: 'Conscierra',
    logo: '/brand/conscierra-logo-fern.png',
    logoAlt: 'Conscierra',
    homeAriaLabel: 'Conscierra home',
    icon: '/brand/conscierra-icon-fern.png',
  },
  XCENTRAL: {
    productName: 'XCentral',
    logo: '/brand/xcentral-logo-full-colour.png',
    logoAlt: 'XCentral',
    homeAriaLabel: 'XCentral home',
    // #23627: the redrawn X mark (docs/brand/xcentral/) is the icon-sized asset.
    icon: '/brand/xcentral-mark.svg',
  },
};

/** Normalises an API-supplied brand string to a known {@link Brand}, defaulting to Conscierra. */
export function normalizeBrand(value: string | null | undefined): Brand {
  return value === 'XCENTRAL' ? 'XCENTRAL' : DEFAULT_BRAND;
}
